import { render, staticRenderFns } from "./CodigoIssfa.vue?vue&type=template&id=0c413741"
import script from "./CodigoIssfa.vue?vue&type=script&lang=js"
export * from "./CodigoIssfa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports